import { Level } from '@/types/game';

export const SHEEP_TILE_TYPES = Array.from({ length: 16 }, (_, index) => `block_${index + 1}`);
export const FIRST_PRACTICE_LEVEL = 2;

/** Keep the retired tutorial slot for existing save IDs; playable practice levels start at 2. */
export const LEVEL_CONFIG = [
  { types: 3, cardsPerType: 6, layers: 2 },
  { types: 16, cardsPerType: 9, layers: 5 },
  { types: 16, cardsPerType: 12, layers: 6 },
  { types: 16, cardsPerType: 15, layers: 7 },
];

export const LEVELS: Level[] = [
  {
    id: 2,
    name: '每日一关',
    difficulty: 'easy',
    cardTypes: SHEEP_TILE_TYPES,
    cardCount: LEVEL_CONFIG[1].types * LEVEL_CONFIG[1].cardsPerType,
    description: '16 种农场图案，多层主牌区与两侧备用牌堆。'
  },
  {
    id: 3,
    name: '极限挑战',
    difficulty: 'hard',
    cardTypes: SHEEP_TILE_TYPES,
    cardCount: LEVEL_CONFIG[2].types * LEVEL_CONFIG[2].cardsPerType,
    description: '开始有挑战了！'
  },
  {
    id: 4,
    name: '羊羊挑战',
    difficulty: 'hard',
    cardTypes: SHEEP_TILE_TYPES,
    cardCount: LEVEL_CONFIG[3].types * LEVEL_CONFIG[3].cardsPerType,
    description: '更深的牌堆，留意卡槽里的每一个空位。'
  },
];

export const practiceNumber = (id: number) => Math.max(1, id - FIRST_PRACTICE_LEVEL + 1);
